/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramDashboardCard } from './programDashboardCard';


import { ValidateUtils } from 'app/shared/utils';

export class ProgramDashboardCatalog { 
    dashboards: Array<ProgramDashboardCard>;

    constructor(item?: Partial<ProgramDashboardCatalog>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            dashboards: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.dashboards : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProgramDashboardCatalog.isValid,
        };
    }

    static isValid(obj: ProgramDashboardCatalog): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProgramDashboardCatalog.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.dashboards.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

